import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    exactMatch: {
        marginTop: 12,
        marginRight: 8,
        borderColor: '#757575',
        '& .MuiChip-label': {
            color: '#F5F5F5'
        }
    },
    exactMatchCounter: {
        color: '#757575'
    }
});
